import { createProvider } from './vue-apollo'
import onErrorLink from './apollo-link-onerror'

// Create default provider
export const apolloProvider = createProvider({ link: onErrorLink })
